<section>
    <ul class="list-group">
        @for(choice of data; track choice; let i = $index) {
        <li class="list-group-item">
            <div class="sticker sticker-xs me-2" [ngClass]="{'secondary': i > 0}">{{i + 1}}</div>
            <label>{{choice.value}}</label>
        </li>
        }
    </ul>
</section>